export default "__VITE_ASSET__KIUJC36Z__"